import {Tooltip} from 'antd';
import {observer} from 'mobx-react';
import styles from './style.module.scss';

export const SidebarTooltip = observer(props => {
  return <Tooltip {...props} overlayClassName={props.overlayClassName ? props.overlayClassName : styles.tooltipOverlay}>
    {props.children}
  </Tooltip>;
});
